module.exports = __webpack_public_path__ + "static/logos-creatives-mobile-d328b39d885c4b0f8491c49e0c1b3f4d.png";